export const getContainerTypeCellTitle = (containerTypeTitle: string, appliedWasteTypeTitle: string) => {
  let title = "";
  if (containerTypeTitle) {
    title += `${containerTypeTitle} `;
  }
  title += appliedWasteTypeTitle;

  return title;
};
